export const restApiPostsEvents = async (err) => {
  if (err) {
    console.error(err);
  }
  const eventsPostsContainer = document.querySelector('.rest-api-events-list'),
    blogId = document.getElementsByTagName('html')[0].id;
  var blogName = '';

  if (blogId) {
    if (blogId === 'blog-4') {
      blogName = 'kronechurwalden';
    }
    if (blogId === 'blog-5') {
      blogName = 'pradaschier';
    }
    if (blogId === 'blog-6') {
      blogName = 'lenzerhorn';
    }
    if (blogId === 'blog-7') {
      blogName = 'posthotelvalbella';
    }
    if (blogId === 'blog-8') {
      blogName = 'swissheidihotel';
    }
    if (blogId === 'blog-9') {
      blogName = 'heid360';
    }
  } else {
    blogName = '';
  }
  const currentUrl = window.location.href;
  const getSubdomain = (url) => {
    let domain = url;
    if (url.includes('://')) {
      domain = url.split('://')[1];
    }
    const subdomain = domain.split('.')[0];
    return subdomain;
  };

  if (eventsPostsContainer) {
    if (
      // check if production or staging environment
      getSubdomain(currentUrl) != 'new' &&
      getSubdomain(currentUrl) != 'alpintrend'
    ) {
      addPostsChunk(
        'https://' + window.location.hostname + '/wp-json/events/all-posts',
        true,
        0,
        eventsPostsContainer,
      );
    } else {
      addPostsChunk(
        '/' + blogName + '/wp-json/events/all-posts',
        true,
        0,
        eventsPostsContainer,
      );
    }
  }

  function addPostsChunk(
    restApiUrl,
    replaceCurList = false,
    count = 0,
    postsContainer,
  ) {
    //
    // load more api call - get the current chunk of posts from the REST API
    //

    let postsShown = 99;

    fetch(restApiUrl)
      .then((response) => response.json())
      .then((data) => {
        // If filter is clicked, start output with first post
        // If more button is clicked, start output with the next chunk
        if (replaceCurList) {
          data.splice(0, 0);
        } else {
          data.splice(0, postsShown);
        }

        const newData = chunkArray(data, postsShown),
          currentChunk = newData[count];

        if (count <= newData.length) {
          const items = [];

          currentChunk.forEach((key, index) => {
            const postId = currentChunk[index].id,
              postTitle = currentChunk[index].title,
              postExcerpt = currentChunk[index].excerpt,
              postImg = currentChunk[index].featured_img_src,
              postTextfield = currentChunk[index].text_field,
              postStartDate =
                currentChunk[index].event_start_date.substring(0, 6) + '-',
              postEndDate = currentChunk[index].event_end_date.substring(0, 6),
              postUrl = currentChunk[index].url;

            let dateOutput = '';
            // If post hast text field, use it, otherwise use postStartDate and postEndDate
            if (postTextfield) {
              dateOutput =
                '<span class="event-start-date">' + postTextfield + '</span>';
            } else {
              dateOutput =
                '<span class="event-start-date">' +
                postStartDate +
                '</span><span class="event-end-date">' +
                postEndDate +
                '</span>';
            }

            const slideContents = `<div class="wp-block-group is-layout-constrained wp-block-group-is-layout-constrained">
                  <div class="event-dates">
                  ${dateOutput}
                  </div>
                  <div class="wp-block-cover">
                  <span aria-hidden="true" class="wp-block-cover__background has-background-dim-0 has-background-dim"></span>
                  ${postImg}
                  </div>
               
                <h4 class="wp-block-heading">${postTitle}</h4>
                <p>${postExcerpt}</p>
                <div class="wp-block-buttons is-layout-flex wp-block-buttons-is-layout-flex">
                  <div class="wp-block-button is-style-external is-style-default">
                    <a href="${postUrl}" class="wp-block-button__link wp-element-button">Mehr erfahren</a>
                  </div>
                </div></div>`;

            let swiperSlides = '';
            if (index % 3 === 0) {
              if (index === 0) {
                swiperSlides = `<div class="swiper-slide post-${postId}">`;
              } else {
                swiperSlides = `</div><div class="swiper-slide post-${postId}">`;
              }
            }

            swiperSlides += slideContents;

            if (currentChunk.length === index + 1) {
              swiperSlides += `</div>`;
            }

            items.push(swiperSlides);
          });

          // If filter is clicked, start output with first post
          // If more button is clicked, start output with the next chunk
          if (replaceCurList) {
            postsContainer.innerHTML = items.join('');
          } else {
            postsContainer.insertAdjacentHTML('beforeend', items.join(''));
          }
        }
      })
      .catch((err) => {
        console.log('Something went wrong!', err);
      });
  }

  function chunkArray(array, size) {
    const chunkyArr = [];
    let index = 0;
    while (index < array.length) {
      chunkyArr.push(array.slice(index, size + index));
      index += size;
    }

    return chunkyArr;
  }
};

import.meta.webpackHot?.accept(restApiPostsEvents);
